<template>
  <v-card flat>
    <v-row
      no-gutters
      class="px-4"
    >
      <v-col
        cols="12"
        class="px-3"
        :sm="6"
        :md="3"
      >
        <WDatePicker
          :date.sync="dateFrom"
          :label="dateFromLabel"
          @update:date="setStartDate"
        />
      </v-col>
      <v-col
        cols="12"
        class="px-3"
        :sm="6"
        :md="3"
      >
        <WDatePicker
          :date.sync="dateTo"
          :label="dateToLabel"
          :min="dateFrom || null"
          @update:date="setEndDate"
        />
      </v-col>
      <v-col
        cols="12"
        class="px-3"
        :sm="6"
        :md="2"
      >
        <v-text-field
          v-model="supportNumber"
          label="Номер"
          required
          @change="onSupportNumberChange"
        />
      </v-col>
      <v-col
        cols="12"
        class="px-3"
        :sm="6"
        :md="4"
      >
        <WBDOfficeSelectorFilter
          :remote-list="[]"
          :label="'Поиск объектов'"
          :remote-option-value="''"
          select-active
          @onOfficeSelectorFilterChange="onSelectedOfficeListChange"
        />
      </v-col>
      <v-col
        v-if="!lite || showLaborerList"
        cols="12"
        class="px-3"
        :sm="6"
        :md="4"
      >
        <WBDLaborerListFilterComponent
          :remote-list="[]"
          boarded
          @onLaborerSelectorFilterChange="onSelectedLaborerListChange"
        />
      </v-col>
      <v-col
        v-if="!lite"
        cols="12"
        class="px-3"
        :sm="6"
        :md="4"
      >
        <v-autocomplete
          v-model="selectedStatusList"
          :items="allowedStatusList"
          multiple
          return-object
          item-value="id"
          item-text="title"
          label="Поиск статусов"
          @change="onSelectedStatusListChange"
        />
      </v-col>
      <v-col
        v-if="!lite"
        cols="12"
        class="px-3"
        :sm="6"
        :md="4"
      >
        <v-select
          v-model="selectedLaborerStatus"
          clearable
          :items="laborerStatusList"
          :item-text="'title'"
          :item-value="'id'"
          label="Тип работника"
          @change="$emit('update:laborerStatus', $event)"
        />
      </v-col>
      <v-col
        v-if="!lite"
        cols="12"
        class="px-3"
        :sm="6"
        :md="4"
      >
        <v-select
          v-model="selectedStartConfirmationOption"
          clearable
          :items="startConfirmationOptionList"
          :item-text="'title'"
          :item-value="'id'"
          label="Подтверждение начала"
          @change="$emit('update:startConfirmationOption', $event)"
        />
      </v-col>
      <v-col
        v-if="!lite"
        cols="12"
        class="px-3"
        :sm="6"
        :md="4"
      >
        <v-select
          v-model="selectedPaymentOption"
          clearable
          :items="paymentStatusListOption"
          :item-text="'title'"
          :item-value="'id'"
          label="Статус оплаты"
          @change="$emit('update:relayPayment', $event)"
        />
      </v-col>
      <v-col
        v-if="!lite"
        cols="12"
        class="px-3"
        :sm="6"
        :md="4"
      >
        <v-select
          v-model="selectedPaymentReceiptOption"
          clearable
          :items="paymentReceiptListOption"
          :item-text="'title'"
          :item-value="'id'"
          label="Статус загрузки чека"
          @change="$emit('update:relayPaymentReceipt', $event)"
        />
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import WDatePicker from '@/components/common/date-picker/index.vue'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import WBDOfficeSelectorFilter from '@/components/common/filter/office-selector-filter'
import WBDLaborerListFilterComponent from '@/components/common/filter/laborer-filter'

export default {
  name: 'WBDListFilterComponent',
  components: {
    WBDLaborerListFilterComponent,
    WDatePicker,
    WBDOfficeSelectorFilter
  },
  props: {
    dateFromLabel: {
      type: String,
      default: 'Создан С'
    },
    dateToLabel: {
      type: String,
      default: 'Создан До'
    },
    lite: {
      type: Boolean,
      default: false
    },
    showLaborerList: {
      type: Boolean,
      default: false
    },
    hideOfficeList: {
      type: Boolean,
      default: false
    },
    dateFrom: {
      type: String
    },
    setStartDate: {
      type: Function
    },
    setEndDate: {
      type: Function
    },
    dateTo: {
      type: String
    },
    modelNumber: {
      type: String
    },
    officeList: {
      type: Array,
      default: () => []
    },
    statusList: {
      type: Array,
      default: () => []
    },
    laborerStatusList: {
      type: Array,
      default: () => []
    },
    laborerStatus: {
      type: String,
    },
    startConfirmationOption: {
      type: String,
    },
    relayPayment: {
      type: String,
    },
    relayPaymentReceipt: {
      type: String,
    },
    allowedStatusList: {
      type: Array,
      default: () => []
    },
    paymentReceiptListOption: {
      type: Array,
      default: () => []
    },
    paymentStatusListOption: {
      type: Array,
      default: () => []
    },
    filteredLaborerList: {
      type: Array,
      default: () => []
    },
    startConfirmationOptionList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      currentYear: null,
      searchLaborer: null,
      officeSearch: null,
      officeLoading: false,
      laborerLoading: false,
      laborerList: [],
      selectedOfficeList: [],
      supportNumber: null,
      selectedLaborerList: [],
      selectedStatusList: [],
      selectedLaborerStatus: null,
      selectedStartConfirmationOption: null,
      selectedPaymentOption: null,
      selectedPaymentReceiptOption: null,
    }
  },
  computed: {
    ...mapGetters({
    }),
    getOfficeList () {
      const requested = this.$store.getters['office/getStoreList']
      if ((!requested || !requested.length) && this.officeList.length) {
        return this.officeList
      }
      return requested
    },
  },
  created () {
    const d = new Date()
    this.currentYear = d.getFullYear()
    // this.requestOfficeList()
    if (this.statusList) {
      this.selectedStatusList = this.statusList
    }

    this.supportNumber = this.modelNumber

    this.selectedLaborerList = this.filteredLaborerList
    this.laborerList = this.filteredLaborerList

    this.selectedOfficeList = this.officeList
    this.selectedLaborerStatus = this.laborerStatus
    this.selectedStartConfirmationOption = this.startConfirmationOption
    this.selectedPaymentOption = this.relayPayment
    this.selectedPaymentReceiptOption = this.relayPaymentReceipt

    this.eventsBus.$on(this.eventNames.DEFAULT_LIST_FILTER_RESET, () => {
      this.currentYear = null
      this.searchLaborer = null
      this.officeSearch = null
      this.officeLoading = false
      this.laborerLoading = false
      this.laborerList = []
      this.selectedOfficeList = []
      this.supportNumber = null
      this.selectedLaborerList = []
      this.selectedStatusList = []
      this.selectedLaborerStatus = null
      this.selectedStartConfirmationOption = null
      this.selectedPaymentOption = null
      this.selectedPaymentReceiptOption = null
    })
  },
  methods: {
    ...mapMutations({
    }),
    ...mapActions({
    }),
    async onSearchLaborer () {
      if (this.searchLaborer && this.searchLaborer.length > 1) {
        this.laborerList = []
        this.laborerLoading = true
        try {
          const list = await this.$store.dispatch(
            'user/getList',
            { params: { searchQuery: this.searchLaborer } }
          )
          this.loading = false
          setTimeout(() => {
            this.laborerLoading = false
          }, 1500)
          this.laborerList = list.data
          if (this.selectedLaborerList) {
            this.selectedLaborerList = this.laborerList.find((item) => this.selectedLaborerList.includes(item.id))
          }
        } catch (error) {
          this.loading = false
          this.laborerLoading = false
        }
      }
    },
    onSelectedLaborerStatusChange () {
      this.$emit('update:laborerStatus', this.selectedLaborerStatus)
    },
    onSelectedStartConfirmationOptionChange () {
      this.$emit('update:startConfirmationOption', this.selectedStartConfirmationOption)
    },
    onSelectedOfficeListChange (data, office) {
      if (office) {
        this.$emit('update:officeList', [
          {
            id: office.id,
            title: office.title,
          }
        ])
      } else {
        this.$emit('update:officeList', [])
      }
    },
    onSupportNumberChange () {
      this.$emit('update:modelNumber', this.supportNumber)
    },

    onSelectedLaborerListChange (id, laborer) {
      if (laborer) {
        this.$emit('update:filteredLaborerList', [
          {
            id: laborer.id,
            fullName: laborer.fullName,
          }
        ])
      } else {
        this.$emit('update:filteredLaborerList', [])
      }
    },
    onSelectedStatusListChange () {
      this.$emit('update:statusList', this.selectedStatusList.map((status) => status))
    },
    async requestOfficeList (page = 1, size = 250) {
      // params.searchQuery = this.searchOffice

      if (!this.officeSearch || this.officeSearch.length < 2) {
        return
      }
      this.officeLoading = true
      try {
        await this.$store.dispatch(
          'office/getModelList',
          {
            params: { 'searchQuery': this.officeSearch.trim(), 'page[number]': page, 'page[size]': size },
            hideLoader: true
          }

        )
        setTimeout(() => {
          this.officeLoading = false
        }, 1500)
        this.loading = false
      } catch (error) {
        console.log(error)
        this.officeLoading = false
      }
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.wbd-footer-bg{
  background: #000000;
  opacity: 0.05;
}
.company-name
{
  font-style: normal;
  font-weight: 800;
  font-size: 22px;
  line-height: 27px;

  /* identical to box height */

  color: #000000;

  opacity: 0.2;
}
</style>
